"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _dist = require("@low6dev/react-utils/dist");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var cornerHeight = "100px";

var StyledWrapper = _styledComponents.default.a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n  height: ", ";\n  margin: 0 0 16px;\n  display: flex;\n  align-items: center;\n  font-family: Flama;\n  background: #010101\n    url(", ");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n\n  cursor: pointer;\n\n  @media (min-width: ", ") {\n    ", ";\n  }\n"])), !process.env.REACT_APP_BANNER_LINK_IMAGE && "260px", (0, _dist.createImageCdnLink)("Toto-Banner-2022-Background-Dick-Advocaat.png"), function (p) {
  return p.theme.screenWidthXs;
}, !process.env.REACT_APP_BANNER_LINK_IMAGE && "230px");

var StyledTotoUrl = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 1;\n  left: 16px;\n  bottom: 16px;\n  text-transform: uppercase;\n  color: white;\n"])));

var StyledCorner = _styledComponents.default.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  left: 16px;\n  display: flex;\n  height: ", ";\n  transform: scale(0.5);\n  transform-origin: 0% 0%;\n"])), cornerHeight);

var StyledLogoWrapper = _styledComponents.default.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n"])));

var StyledTotoLogo = _styledComponents.default.img(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  height: 64px;\n"])));

var StyledContent = _styledComponents.default.span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n  display: flex;\n  align-items: flex-start;\n  padding-left: 16px;\n  padding-top: 48px;\n"])));

var StyledBannerText = _styledComponents.default.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 1;\n  color: white;\n  font-size: 26px;\n  text-transform: uppercase;\n  line-height: 1.15;\n  width: 180px;\n  padding-top: 8px;\n\n  @media (min-width: ", ") {\n    font-size: 24px;\n    width: 260px;\n    padding-top: 8px;\n  }\n\n  @media (min-width: ", ") {\n    font-size: 24px;\n    width: 260px;\n    padding-top: 0;\n  }\n"])), function (p) {
  return p.theme.screenWidthXs;
}, function (p) {
  return p.theme.screenWidthMd;
});

var StyledEnd = _styledComponents.default.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 2;\n  display: flex;\n  justify-content: flex-end;\n  align-self: stretch;\n  background: ", ";\n  width: 50px;\n\n  @media (min-width: ", ") {\n    width: 100px;\n  }\n\n  @media (min-width: ", ") {\n    width: 100px;\n  }\n"])), function (p) {
  return p.theme.colorCardBackground || "white";
}, function (p) {
  return p.theme.screenWidthXs;
}, function (p) {
  return p.theme.screenWidthMd;
});

var StyledFish = _styledComponents.default.img(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  left: 0;\n  width: 44px;\n  transform: translate(-50%, -50%);\n"])));

var StyledPlaceBet = _styledComponents.default.button(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 0;\n  left: 16px;\n  bottom: 44px;\n  text-transform: uppercase;\n  color: white;\n  font-size: 18px;\n  padding: 0;\n\n  & > img {\n    height: 36px;\n  }\n"])));

var StyledPlayResponsibly = _styledComponents.default.span(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  text-align: right;\n  line-height: 1.1;\n  font-size: 8px;\n  color: ", ";\n  padding-right: 8px;\n  padding-top: 16px;\n  padding-left: 8px;\n"])), function (p) {
  return p.theme.colorLabel;
});

var StyledHiddenLink = _styledComponents.default.a(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-size: 0;\n  visibility: hidden;\n"])));

var StyledOverrideImage = _styledComponents.default.img(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: block;\n  margin: 0 auto;\n"])));

var Wrapper = function Wrapper(_ref) {
  var _bannerText, _bannerText2;

  var hasInvalidTotoScores = _ref.hasInvalidTotoScores,
      isInsideTotoIframe = _ref.isInsideTotoIframe,
      bannerText = _ref.bannerText,
      betAmount = _ref.betAmount,
      winAmount = _ref.winAmount,
      textPlaceBet = _ref.textPlaceBet,
      textPlayResponsibly = _ref.textPlayResponsibly,
      textBannerDefault = _ref.textBannerDefault;
  var currencySymbol = process.env.REACT_APP_CURRENCY_SYMBOL;
  var isDev = process.env.NODE_ENV === "development";
  bannerText = (_bannerText = bannerText) === null || _bannerText === void 0 ? void 0 : _bannerText.replace("$1", "".concat(currencySymbol).concat(betAmount === null || betAmount === void 0 ? void 0 : betAmount.toFixed(0)));
  bannerText = (_bannerText2 = bannerText) === null || _bannerText2 === void 0 ? void 0 : _bannerText2.replace("$2", "".concat(currencySymbol).concat((0, _dist.numberWithCommas)(winAmount === null || winAmount === void 0 ? void 0 : winAmount.toFixed(2))));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
      href: process.env.REACT_APP_BANNER_LINK_URL,
      target: "_blank",
      onClick: function onClick() {
        console.log("logging to xtremepush");
        window.xtremepush("tag", "game_banner_clicked", JSON.stringify({
          AppName: process.env.REACT_APP_TITLE
        }));
      },
      children: process.env.REACT_APP_BANNER_LINK_IMAGE ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledOverrideImage, {
        src: process.env.REACT_APP_BANNER_LINK_IMAGE,
        alt: "Toto Banner"
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCorner, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLogoWrapper, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTotoLogo, {
              src: (0, _dist.createImageCdnLink)(process.env.REACT_APP_TOTO_BANNER_LOGO || "Score4-Toto-White-Green4.png")
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledContent, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledBannerText, {
            children: hasInvalidTotoScores ? textBannerDefault : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [bannerText, " ", currencySymbol + (0, _dist.numberWithCommas)(winAmount === null || winAmount === void 0 ? void 0 : winAmount.toFixed(2))]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledPlaceBet, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: (0, _dist.createImageCdnLink)("Toto-Banner-2022-CTA-Button.png")
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledEnd, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledPlayResponsibly, {
            children: textPlayResponsibly
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledFish, {
            src: (0, _dist.createImageCdnLink)("Toto-Banner-Fish-Circle2.png")
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTotoUrl, {
          children: "toto.nl"
        })]
      })
    })
  });
};

var _default = Wrapper;
exports.default = _default;